import { createAxiosClient, ServiceProxyMap } from '@atlassian/temp-client-utils';
import { creditPolicyResponse } from '@atlassian/cssxp-types-billing';
import { UpdateOrderRequest, CustomOrderRequest } from '@atlassian/cssxp-typescommon';

const client = createAxiosClient({ baseURL: '/api/1/cms' }, ServiceProxyMap.ANS);

export const termPaymentVerification = async (
  requestPayload: UpdateOrderRequest | CustomOrderRequest
): Promise<creditPolicyResponse> => {
  const response = await client.post('/financeValidation', requestPayload);
  return response.data;
};

export const getLatestCreditRequestDetails = async (transactionAccountId: string) => {
  try {
    const response = await client.get(`/latestCreditRequest/${transactionAccountId}`);
    return response?.data;
  } catch (e) {
    return {
      ticketNumber: '',
      createdAt: 0,
    };
  }
};
